import { useQuery } from '@tanstack/react-query';

import { type GetCreditReversalSummaryPayload, getCreditReversalSummary } from '~/services/CreditReversalService';

const CREDIT_REVERSAL_SUMMARY_BASE_KEY = 'creditReversalSummary' as const;

export const creditReversalSummaryQueryKeys = {
  all: [CREDIT_REVERSAL_SUMMARY_BASE_KEY] as const,
  detail: (payload: GetCreditReversalSummaryPayload) => [...creditReversalSummaryQueryKeys.all, payload] as const,
};

export function useGetCreditReversalSummary(
  orderIds: Array<string>,
  enabled = true,
  statuses?: GetCreditReversalSummaryPayload['statuses'],
) {
  const payload: GetCreditReversalSummaryPayload = {
    orderIds,
    ...(statuses ? { statuses } : {}),
  };

  return useQuery({
    queryKey: creditReversalSummaryQueryKeys.detail(payload),
    queryFn: ({ signal }) => getCreditReversalSummary(payload, signal),
    enabled: enabled && orderIds.length > 0,
  });
}
